import { makeStyles } from '@material-ui/core/styles';
import InfographicsImage from '../../../../assets/svg/infographicsMoreLikeThis.svg';
import InfographicsImageMobile from '../../../../assets/svg/infographicsMoreLikeThis_mobile.svg';
import { pxToRem } from '../../../../styles/themes/vad/constants';
const useStyles = makeStyles(theme => {
  const { left, right } = theme.mixins;
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      '&.withBg': {
        backgroundColor: ({ params, fields }) =>
          ((params && params.backgroundColor) || (fields && fields.bgColor.value)) || theme.palette.background.default,
        ...theme.shape.fullBleedingBox,
      },
      '&.isApplyHeight': {
        '& .card-description': {
          [theme.breakpoints.up('lg')]: {
            // minHeight: pxToRem(280),
            minHeight: 0,
          },
          [theme.breakpoints.down('md')]: {
            // minHeight: pxToRem(256),
            minHeight: 0,
          },
        },
      },

      '&.isADRelatedEvents': {

        [theme.breakpoints.up('lg')]: {
          padding: `${pxToRem(120)} 0 !important`,
        },

        [theme.breakpoints.down('md')]: {
          padding: `${pxToRem(40)} 0`,
        },

        '& .bg-wrapper': {
          position: 'absolute',
          width: '100%',
          height: '100%',
          left: 0,
          bottom: 0,
          zIndex: 0,

          '& img': {
            backgroundColor: 'transparent',
          },
        },

        '& .slick-slider': {
          '& .slick-slide': {
            overflow: 'hidden',
            backgroundColor: '#FFF',

            '& .imageWrap': {
              overflow: 'hidden',
            },
          }
        },
      },

      '& .infographicsbgImage-moreLikethis': {
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        bottom: 0,
        ...right(0),
        ...left('auto'),
        height: '100%',
        width: '70%',
        transform: `scale(${theme.isDirectionRTL ? '-' : ''}1, 1)`,
        backgroundImage: `url(${InfographicsImage})`,
        [theme.breakpoints.down('md')]: {
          backgroundImage: `url(${InfographicsImageMobile})`,
          width: '67%',
        },
      },

      '& .Type3': {
        backgroundColor: 'transparent',
        marginBottom: 0,
        '& .slick-track': {
          [theme.breakpoints.down('lg')]: {
            paddingBottom: '83px',
          },
        },
        '& .slick-prev, & .slick-next': {
          top: '50%',
          transform: 'translateY(-50%)',
        },
        '& .slick-prev': {
          left: pxToRem(-20),
          right: 'auto',
        },
        '& .slick-next': {
          left: 'auto',
          right: pxToRem(-20),
        },
        '& .slick-prev > button, & .slick-next > button': {
          borderWidth: ({ params }) =>
            params && params.backgroundColor ? 0 : 1,
          backgroundColor: ({ params }) =>
            params && params.backgroundColor ? theme.mixins.White() : theme.mixins.White(0),
          '& svg': {
            color: ({ params }) =>
              params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(),
          },
          '&:hover': {
            backgroundColor: ({ params }) =>
              params && params.backgroundColor ? theme.mixins.RussianViolet() : theme.mixins.Black(300),
            '& svg': {
              color: ({ params }) =>
                params && params.backgroundColor ? theme.mixins.White() : theme.mixins.Black(),
            },
          },
        },
      },
      '& .main-heading': {
        color: ({ params }) => (params && params.textColor) || theme.palette.text.primary,
      },
    },
  }
});

export default useStyles;
